import fetch from "auth/FetchInterceptor";

const MailConfigService = {};

MailConfigService.GetMailSettings = async function () {
  return fetch({
    url: "/EmailConfiguration/GetMailSettings",
    method: "get",
  });
};

MailConfigService.UpdateSettings = async function (data) {
  return fetch({
    url: "/EmailConfiguration/UpdateSettings",
    method: "post",
    data,
  });
};

export default MailConfigService;
